var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32996 4.79L2.08996 0.554C1.99738 0.460762 1.88733 0.386672 1.76612 0.33596C1.6449 0.285249 1.51489 0.258909 1.38349 0.258444C1.2521 0.25798 1.1219 0.2834 1.00033 0.333254C0.878756 0.383108 0.768195 0.456419 0.674957 0.549C0.581718 0.641582 0.507628 0.751622 0.456917 0.872838C0.406205 0.994053 0.379865 1.12407 0.379401 1.25546C0.378936 1.38686 0.404357 1.51706 0.454211 1.63863C0.504064 1.7602 0.577375 1.87076 0.669957 1.964L4.20996 5.504L0.669957 9.04C0.482979 9.2283 0.378463 9.48317 0.379401 9.74854C0.380338 10.0139 0.486653 10.268 0.674957 10.455C0.863261 10.642 1.11813 10.7465 1.38349 10.7456C1.64886 10.7446 1.90298 10.6383 2.08996 10.45L6.32996 6.21C6.42369 6.11704 6.49808 6.00644 6.54885 5.88458C6.59962 5.76272 6.62576 5.63201 6.62576 5.5C6.62576 5.36799 6.59962 5.23728 6.54885 5.11542C6.49808 4.99357 6.42369 4.88296 6.32996 4.79Z",
    fill: "#4C7F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4d80bf08894435364128eaf7dfa6ff7a.svg";
export { ForwardRef as ReactComponent };